export default __webpack_public_path__ + "static/media/pyramids.63682222.svg";